module.exports = __webpack_public_path__ + "img/SeleniumHQ.f651ee9e.png";